export enum EapColors {
  BlueInteraction = '#1f2df5', // $ds-color-interactive
  BlueHover = '#151f8b', // $ds-color-interactive-hover
  BlueLink = '#1f2df5', // $ds-color-interactive
  BlueInfo = '#01a2c7', // $ds-color-info
  BluePrimary = '#1f2df5', // $ds-color-primary
  GreenSeverityLow = '#197729', // $ds-color-severity-low
  GreyCopy = '#454656', // $ds-color-text-dark
  GreyStrokeInactive = '#9294a9', // $ds-gray-600
  GreyPageBackground = '#eff0f6', // $ds-gray-100
  GreenStatusPassed = '#197729', // $ds-color-severity-low
  RedError = '#eb0b0c', // $ds-color-error
  RedStatusFailed = '#b90d0d', // $ds-color-severity-critical
  RedSeverityCritical = '#b90d0d', // $ds-color-severity-critical
  OrangeSeverityHigh = '#bd6706', // $ds-color-severity-medium
  OrangeStatusReview = '#bd6706', // $ds-color-severity-medium
  White = '#fff', // $ds-white
  SeverityRank5 = '#b90d0d', // $ds-color-severity-rank-5
  SeverityRank4 = '#b90d0d', // $ds-color-severity-rank-4
  SeverityRank3 = '#bd6706', // $ds-color-severity-rank-3
  SeverityRank2 = '#01a2c7', // $ds-color-severity-rank-2
  SeverityRank1 = '#1f2df5', // $ds-color-severity-rank-1
  BarTextureSeverityRank4 = '#fddad7', // $ds-red-100
  BarTextureSeverityRank3 = '#fee8d7', // $ds-orange-100
  BarTextureSeverityRank2 = '#def8ff', // $ds-teal-100
  BarTextureSeverityRank1 = '#dbe3fe', // $ds-blue-100
}

export const SeverityRankColourMap: Map<number, EapColors> = new Map([
  [5, EapColors.SeverityRank5],
  [4, EapColors.SeverityRank4],
  [3, EapColors.SeverityRank3],
  [2, EapColors.SeverityRank2],
  [1, EapColors.SeverityRank1],
]);
